import { contactsData } from '../data/contactsData';
import { headerData } from '../data/headerData';
import { buildVCard, downloadVCard } from './vcard';

const SITE_URL = 'https://miretu.vercel.app';

// The site's own contact details as a vCard string.
export const contactCard = () => {
    const [city, country] = (contactsData.address || '').split(',').map((part) => part.trim());
    return buildVCard({
        name: headerData.name,
        title: headerData.role,
        org: headerData.company,
        email: contactsData.email,
        phone: contactsData.phone,
        url: SITE_URL,
        city,
        country,
    });
};

export const saveContact = () => downloadVCard(contactCard(), 'miretu-jaleta.vcf');

export const canNativeShare = () => typeof navigator !== 'undefined' && typeof navigator.share === 'function';

// Opens the native share sheet where it exists (phones, some desktops),
// otherwise copies the link. Resolves to 'shared' | 'cancelled' | 'copied' | 'failed'.
export async function shareSite() {
    const data = {
        title: document.title,
        text: `${headerData.name}, ${headerData.role}`,
        url: `${window.location.origin}/`,
    };
    if (canNativeShare()) {
        try {
            await navigator.share(data);
            return 'shared';
        } catch (e) {
            if (e && e.name === 'AbortError') return 'cancelled';
        }
    }
    try {
        await navigator.clipboard.writeText(data.url);
        return 'copied';
    } catch (e) {
        return 'failed';
    }
}
